<template>
  <section
    id="example-job"
    class="co-bg-striped"
  >
    <div class="co-container-md py-12 sm:py-16">
      <div class="mb-12 px-4 text-center md:px-0">
        <h2 class="co-display-7 co-mb-16 tracking-[.15em]">
          スカウト・求人例
        </h2>
      </div>
      <div class="px-4 md:flex md:px-0">
        <div class="mb-5 w-full bg-co-gray-200 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-3 md:mb-0">
          <div class="p-5">
            <div class="mb-5">
              <img
                src="~/assets/images/Te/TeCareerAbout/Index/Example/career-example-photo-1.jpg"
                alt="BtoBサービス運営 / エンジニア"
                loading="lazy"
              >
            </div>
            <h3 class="te-example-title co-display-10 mb-5">
              BtoBサービス運営 / エンジニア
            </h3>
            <div class="co-display-13">
              <span class="block">■ 仕事内容</span>
              <p class="mb-4">
                当社が提供するサービスにおいてサーバーサイドのシステム構築をRuby on Railsなどを用いて開発していただきます。
              </p>
              <span class="block">■ 求めるスキル・経験</span>
              <ul class="m-0 list-disc pl-7">
                <li>Ruby/Ruby on Rails</li>
                <li>Java</li>
                <li>Swift</li>
              </ul>
              <p>
                上記言語での開発経験、スクールでの学習経験者
              </p>
              <span class="mt-4 block">■ 給料詳細</span>
              <p>年収300〜450万</p>
            </div>
          </div>
        </div>
        <div class="mb-5 w-full bg-co-gray-200 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-3 md:mb-0">
          <div class="p-5">
            <div class="mb-5">
              <img
                src="~/assets/images/Te/TeCareerAbout/Index/Example/career-example-photo-2.jpg"
                alt="広告代理事業運営 / Webコンサルタント"
                loading="lazy"
              >
            </div>
            <h3 class="te-example-title co-display-10 mb-5">
              広告代理事業運営 / Webコンサルタント
            </h3>
            <div class="co-display-13">
              <span class="block">■ 仕事内容</span>
              <p class="mb-4">
                検索エンジンから集客に力を入れている企業への提案。1年後を目安とし2〜5名の営業チームのマネジメント業務をしていただきます。
              </p>
              <span class="block">■ 求めるスキル・経験</span>
              <ul class="m-0 list-disc pl-7">
                <li>アウトバンド営業の経験（業界不問）</li>
                <li>手法問わず、営業経験（業界不問）</li>
              </ul>
              <span class="mt-4 block">■ 給料詳細</span>
              <p>年収 350〜850万円</p>
            </div>
          </div>
        </div>
        <div class="w-full bg-co-gray-200 shadow-[0_0_4px_rgba(51,51,51,0.2)] md:mx-3">
          <div class="p-5">
            <div class="mb-5">
              <img
                src="~/assets/images/Te/TeCareerAbout/Index/Example/career-example-photo-3.jpg"
                alt="受託・自社サービス制作/Webデザイナー"
                loading="lazy"
              >
            </div>
            <h3 class="te-example-title co-display-10 mb-5">
              受託・自社サービス制作/Webデザイナー
            </h3>
            <div class="co-display-13">
              <span class="block">■ 仕事内容</span>
              <p class="mb-4">
                ECサイト構築などのWeb系プロジェクト・業務系システムのUI/UX・ゲーム関連などのデザイン業務になります。
              </p>
              <span class="block">■ 求めるスキル・経験</span>
              <ul class="m-0 list-disc pl-7">
                <li>学歴不問・デザイナーとしてのスキルをお持ちの方</li>
                <li>ECサイトのデザイン経験</li>
                <li>UI/UXに関するデザインの経験</li>
              </ul>
              <span class="mt-4 block">■ 給料詳細</span>
              <p>年収300〜600万円</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@media (max-width: 575.98px) {
  .te-example-title {
    font-size: 0.875rem;
    font-weight: bold;
  }
}
</style>
